import React, { useEffect, useState } from 'react'
import { EventEndedText, MomentsTopBanner, Multiphoto, MultiphotoWrapper, NewContentV2 } from '../styles';
import Timer from '../timer';
// import dayjs from 'dayjs';
import { containsDefaultPng, convertDateInTimezone, fetchApi, getInitials } from '../../../utils/methods';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { Heading } from '../../Manager/styles';
import ShareMoment from './ShareMoment';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { GetEventMoments, JoinOrLeaveThemeEvent } from '../../../redux/constants/apiConstants';
import { EventCard, FlexWrapper, NewChampionsCard, NewVideoPlayer } from '../../MainEvents/RecommendEventVideos/styles';
import Thumbnail from '../../Thumbnail';
import { ImageUrl } from '../../../utils/constants';
import { DownAngleV2, UserInitialsMain } from '../../SocialFeedsV2/styles';
import MomentImagesPopup from './MomentImagesPopup';
import SkeletonLoder from '../../common/skeletonLoder';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DropdownButton } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { AdminDeleteIcon, RecognitionWarningIcon, PostButtonIcon, VerticalDotsIcon } from '../../../utils/icons';
import EditMoment from './EditMoment';
import ShareOnSocialFeed from './ShareOnSocialFeed';
import CommonModal from '../../common/CommonModal/CommonModal';
import { DeleteEventMoment } from '../../../redux/constants/apiConstants';

const EventMoments = ({event,getEventDetailsById,userId,history}) => {
  const[shareMomentModal, setShareMomentModal] = useState(false);
  const[sharedMoments, setSharedMoments] = useState([]);
  const[ImagesModal, setImagesModal] = useState(false);
  const[modalData, setModalData] = useState(null);
  const[loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const[editMomentModal, setEditMomentModal] = useState(false);
  const[selectedMoment,setSelectedMoment] = useState({});
  const[shareMomentSocialModal, setShareMomentSocialModal] = useState(false);
  const[shareMomentSocialModalType, setShareMomentSocialModalType] = useState(null);
  const[openDeleteModal,setOpenDeleteModal] = useState(false);
  const [momentId,setMomentId] = useState(null);
  // const dispatch = useDispatch();
  const userCompany = useSelector((state) => state.profileData.userCompany);
  const companyId = userCompany?.id;

  // React.useEffect(() => {
  //   dispatch(getUserCompanyDetails());
  // }, [dispatch]);



  // ---- FETCH ON INITIAL + PAGE CHANGE ----
  useEffect(() => {
    if (companyId && event?.id) {
      getSharedMoments(companyId, page);
    }
  }, [companyId, event?.id, page]);

  // ---- INFINITE SCROLL HANDLER ----
  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

      if (!loading && scrollTop + clientHeight >= scrollHeight - 50) {
        setPage((prevPage) => {
          if (totalPages && prevPage < totalPages) {
            return prevPage + 1;
          }
          return prevPage;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, totalPages]);


  const deleteMoment = async () => {
    const MomentId = momentId; 
    try {
      const res = await fetchApi(`${DeleteEventMoment}/${MomentId}`, "DELETE");
      window.console.log("delete moment response",res)
      if (res.status ==="success") {
        toast.success(res.message);
        getEventDetailsById(event.id)
        getSharedMoments(companyId, page);
      } else {
        toast.error(res.messgae);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };


  
  const openModal = (data) =>{
    setImagesModal(true);
    setModalData(data);
    setSelectedMoment(data);
  }
   
  const closeModal = () =>{
    setImagesModal(false);
    setSelectedMoment({});
  }

  const handleDeleteCancel = () =>{
    setOpenDeleteModal(false);
  }

  const handleDeleteConfirm = () =>{
    deleteMoment();
    setOpenDeleteModal(false);
  }

  const DeleteModal = (moment) =>{
    window.console.log("moment",moment)
    setMomentId(moment.id);
    setOpenDeleteModal(true);
  }



  const joinEvent = async()=>{
    const payload = {event_id:event.id,join_status:1}
    try{
      const res = await fetchApi(JoinOrLeaveThemeEvent, "POST",payload);
      if(res.status === "success"){
        // setWellnessChallengeList(res.data);
        toast.success(res?.message)
        getEventDetailsById(event.id)
      }else{
        toast.error(res.message);
      }
    }catch(error){
      toast.error(error)
    }
  }




  const getSharedMoments = async(companyId,page)=>{

    const limit = 9;

    // if (loading || (!hasMore)) return; 

    try{
      setLoading(true); 
      const res = await fetchApi(GetEventMoments + `/${companyId}/${event.id}/${page}/${limit}`, "GET");
      if(res.status === "success"){
        const { event_moments, pagination } = res.data || {};
        setSharedMoments((prev) =>
          page === 1 ? event_moments : [...prev, ...event_moments]
        );
        setTotalPages(pagination.total_pages);
        // setSharedMoments(res?.data?.event_moments)
        setLoading(false);
      }else{
        toast.error(res.message);
        setLoading(false);
      }
    }catch(error){
      toast.error(error)
      setLoading(false);
    }finally {
      setLoading(false);
    }
  }

  const TopBanner = ()=>(
    <MomentsTopBanner>
      <div className='container'>
        <div>
          <div className='title'> 📸 Share Your Event Moments!</div>
          <div className='sub-title'>Join the event to start sharing your photos and thoughts with everyone — and be part of the celebration! 🎉✨</div>
        </div>
     
        <div className='end-col'>
          <div> {moment(convertDateInTimezone(event.start_date)._d) > new Date() ? <Timer data={moment(convertDateInTimezone(event.start_date)._d)} isBackgroundColor={"transparent"}   isTextColor={"#B54D93"}  />: 
            moment(convertDateInTimezone(event.start_date)._d) < new Date()   ?  <Timer data={moment(convertDateInTimezone(event.end_date)._d)} isBackgroundColor={"transparent"} isTextColor={"#B54D93"} startText={true} endTetxt={"left"}/>:null} </div>

          {moment(convertDateInTimezone(event.start_date)._d) < new Date() && !event?.event_join_status ? <CommonButtonPopup height="48px" width="200px" 
          // disabled={ }
            onClick={()=>joinEvent()}
          >
          Join Event
          </CommonButtonPopup>: event?.event_join_status === 1 ? <CommonButtonPopup height="48px" width="200px" 
          // disabled={ }
            onClick={()=>setShareMomentModal(true)}
          >
          Share moment
          </CommonButtonPopup> : null }
        </div> 
      </div>
    </MomentsTopBanner>
  )

  const fallBack = (e) => {
    e.target.src = "/public/images/neutral_avatar.svg";
  };

  const setEditMomentModalFromDetailPopUp= ()=>{
    setEditMomentModal(true);
    setImagesModal(false)

  }

  const sharedMomentsCard = ()=>(
    <>
      <Heading margin="28px 0px"> Shared Moments</Heading>
      <div>
        <FlexWrapper >
          {sharedMoments?.map((item, id) => (
            <NewChampionsCard key={id}>
              <EventCard>
                <NewVideoPlayer>
                  {item.images.length==2?
                    <MultiphotoWrapper onClick={() =>{openModal(item);setSelectedMoment(item);}}>
                      <Multiphoto width="197px" height="252px" isPhotoShrink="true">
                        <img onError={fallBack} src={`${ImageUrl}/${item.images?.[0]}`}/>
                      </Multiphoto>
                      <Multiphoto width="197px" height="252px" isPhotoShrink="true">
                        <img onError={fallBack} src={`${ImageUrl}/${item.images?.[1]}`}/>
                      </Multiphoto>
                    </MultiphotoWrapper>:
                    item.images.length==3?
                      <MultiphotoWrapper onClick={() => openModal(item)}>
                        <Multiphoto width="400px" height="126px">
                          <img onError={fallBack} src={`${ImageUrl}/${item.images?.[0]}`} style={{height:"126px"}}/>
                        </Multiphoto>
                        <div className='image-wrap' style={{display:'flex', flexDirection:'row',width:'100%'}}>
                          <Multiphoto width="50%" height="126px">
                            <img onError={fallBack} src={`${ImageUrl}/${item.images?.[1]}`} style={{width:"100%",height:"126px"}}/>
                          </Multiphoto>
                          <Multiphoto width="50%" height="126px">
                            <img onError={fallBack} src={`${ImageUrl}/${item.images?.[2]}`} style={{width:"100%",height:"126px"}}/>
                          </Multiphoto>
                        </div>
                      </MultiphotoWrapper>:
                      item.images.length==4?
                        <MultiphotoWrapper onClick={() => openModal(item)}>
                          <Multiphoto width="310px" height="100%">
                            <img onError={fallBack} src={`${ImageUrl}/${item.images?.[0]}`} />
                          </Multiphoto>
                          <div className='image-wrap'>
                            <Multiphoto width={"83px"} height="83px">
                              <img onError={fallBack} src={`${ImageUrl}/${item.images?.[1]}`} style={{height:"83px"}}/>
                            </Multiphoto>
                            <Multiphoto  width={"83px"} height="83px">
                              <img onError={fallBack} src={`${ImageUrl}/${item.images?.[2]}`} style={{height:"83px"}}/>
                            </Multiphoto>
                            <Multiphoto  width={"83px"}   height="83px" background="1">
                              <img onError={fallBack} src={`${ImageUrl}/${item.images?.[3]}`} style={{height:"83px"}}/>
                              {/* <div className='backdrop' style={{height:"83px",width:'83px'}}>+{item.images?.length-4}</div> */}
                            </Multiphoto>
                          </div>
                        </MultiphotoWrapper>: item.images.length > 4 ?
                          <MultiphotoWrapper onClick={() => openModal(item)}>
                            <Multiphoto width="310px" height="100%">
                              <img onError={fallBack} src={`${ImageUrl}/${item.images?.[0]}`} style={{height:"253px"}}/>
                            </Multiphoto>
                            <div className='image-wrap'>
                              <Multiphoto width={"83px"} height="83px">
                                <img onError={fallBack} src={`${ImageUrl}/${item.images?.[1]}`} style={{height:"83px"}}/>
                              </Multiphoto>
                              <Multiphoto  width={"83px"} height="83px">
                                <img onError={fallBack} src={`${ImageUrl}/${item.images?.[2]}`} style={{height:"83px"}}/>
                              </Multiphoto>
                              <Multiphoto  width={"83px"}   height="83px" background="1">
                                <img onError={fallBack} src={`${ImageUrl}/${item.images?.[3]}`} style={{height:"83px"}}/>
                                <div className='backdrop' style={{height:"83px",width:'83px'}}>+{item.images?.length-4}</div>
                              </Multiphoto>
                            </div>
                          </MultiphotoWrapper>:                <Thumbnail
                            onClick={() => openModal(item)}
                            style={{ cursor: 'default',objectFit:'cover' }} 
                            src={`${ImageUrl}/${item?.images?.[0]}`}
                            alt={'img'}
                          />}
                </NewVideoPlayer>
                <NewContentV2 newPadding={'newPadding'} style={{ minHeight: 'auto' }} isCardPadding={"0"}>
                  <div className='firstContainer'>
                    <div className='captionText' title={item?.text}>
                      {item?.text}
                    </div>
                  </div>
                  <div className='user-details'>
                    <div className='row-one'>
                      <div className='profile'>
                        {!containsDefaultPng(item.moment_owner.profile_image)?
                          <img src={ImageUrl + "/" +item.moment_owner.profile_image}/>:
                          <UserInitialsMain font>{`${getInitials(item.moment_owner?.post_owner_name)}`}</UserInitialsMain>}
                      </div>
                      <div className='privacy-admin'>
                        <div className='name'>{item.moment_owner?.post_owner_name}</div>
                        <div className="timeLoactionContainer">
                          <div className='location'>{item.moment_owner?.location}</div>
                          {item.moment_owner?.location ? <div style={{color:"#BDBDBD"}}>|</div> :null}
                          <div className='location'>{item?.time_ago}</div>
                        </div>
                      </div>
                    </div>

                    {userId === item.moment_owner?.uid && event?.event_status != "over" ? <div className='column-2'>
                      {!item?.post_id ? <div className='share-icon' onClick={()=>{setSelectedMoment(item);setShareMomentSocialModal(true);}}>{PostButtonIcon('#F37A65')}</div>:null}
                      <DownAngleV2  feed>
                        <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>}>
                          <Dropdown.Item onClick={()=>{setSelectedMoment(item);setEditMomentModal(true);}}>
                            {("Edit moment")}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={()=> DeleteModal(item)}>
                            {("Delete moment")}
                          </Dropdown.Item>
                        </DropdownButton>
                      </DownAngleV2>
                    </div>:null}
                  </div>
                </NewContentV2>
              </EventCard>
            </NewChampionsCard>
          ))}

          {loading ? 
            Array.from({ length: 20 }).map((_, index) => (
              <NewChampionsCard key={index}>
                <EventCard style={{backgroundColor:'unset'}}>
                  <SkeletonLoder width={"400px"} height={"252px"} />
                </EventCard>
              </NewChampionsCard>
            ))

            :null}
        </FlexWrapper>
      </div>
      {ImagesModal && <MomentImagesPopup showModal={ImagesModal}  onClose={closeModal} modalData={modalData} setSelectedMoment={setSelectedMoment} setEditMomentModal={setEditMomentModalFromDetailPopUp} userId={userId}  getEventDetailsById={getEventDetailsById} getSharedMoments={getSharedMoments}  event={event} companyId={companyId} page={page} shareMoment={()=>setShareMomentSocialModal(true)}/>}
      {editMomentModal && <EditMoment onClose={()=>{setEditMomentModal(false);setSelectedMoment({})}} showModal={editMomentModal} moment={selectedMoment}  getSharedMoments={getSharedMoments} companyId={companyId} page={page}  getEventDetailsById={getEventDetailsById} event={event}/>}
      {shareMomentSocialModal && <ShareOnSocialFeed onHide={()=>{setShareMomentSocialModal(false);setShareMomentSocialModalType(null)}} showModal={shareMomentSocialModal} heading={shareMomentSocialModalType === "upload" ? 'Moment Successfully Uploaded!' : 'Share moments on social feed'} moment={selectedMoment} type={shareMomentSocialModalType} history={history}/>}
      {openDeleteModal && <CommonModal
        show={openDeleteModal}
        icon={RecognitionWarningIcon("#C13D4D")}
        title="Delete Moment"
        description="Are you sure you want to delete this moment?"
        subDescription="This action cannot be undone, and the post will be permanently removed from the system."
        onCancel={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        cancelText="Keep moment"
        confirmButtonText="Delete Permanently"
        buttonIcon={AdminDeleteIcon()}
        confirmButtonWidth="198px"
        modalHeight="244px"
        descriptionColor="#CE7841"
        isFontSize={"16px"}
        isPopupMargin={"-10px 0 0 0"}
      />
      }
    </>
  )

  const SharedMoments = ()=>(
    <>
      
    
      {sharedMoments.length
        ? sharedMomentsCard() 
        : 
        sharedMoments.length && !event?.event_join_status ? <><Heading margin="28px 0px"> Shared Moments</Heading> <MomentsTopBanner isBackgroundColor={"#F2F5FB"} isMomentPadding={"20px 40px"}>
          <div className='container'>
            <div className='shared-container'>
              <div className='title'> 📸 Join the Fun!</div>
              <div className='sub-title' style={{textAlign:'center'}}>People from your company have already posted their Moments. Don’t miss out — share your photos to join the fun <br/> and see what everyone’s shared!</div>
            </div>
          </div>
        </MomentsTopBanner></>:null}
    </>
  )
  
  return (
    <>
      {event?.event_status === "over" || event?.user_moment_status  ? null :   TopBanner()}

      {event?.event_status === "over"  ?  <EventEndedText>The window to share your Moments for this event has ended.</EventEndedText>: null}

      {!event?.event_join_status && event?.event_status === "over" ? null : event?.event_join_status ? SharedMoments() : null}

      {/* Popups */}
      {shareMomentModal && <ShareMoment  onClose={(upload)=>{setShareMomentModal(false);if(upload){setShareMomentSocialModal(true);setShareMomentSocialModalType('upload')}}} showModal={shareMomentModal} event={event}  getSharedMoments={getSharedMoments} companyId={companyId} page={page}  getEventDetailsById={getEventDetailsById} setSelectedMoment={setSelectedMoment}/>}
    </>
  )
}

EventMoments.propTypes = {
  event: PropTypes.object,
  getEventDetailsById:PropTypes.func,
  userId:PropTypes.number,
  history:PropTypes.object,
}

export default EventMoments